module.exports = __webpack_public_path__ + "assets/img/portfolio-big-04.6d8fec1a.png";